import { useMutation, UseMutationResult } from 'react-query';
import { HubSpotPayload, UserAPI } from 'api/user';

export const useUpdateHubspotMutation = (): UseMutationResult<
  void,
  unknown,
  HubSpotPayload
> => {
  return useMutation((payload) => UserAPI.updateHubspot(payload));
};
